import type { GetPeopleQuery, GetPeopleResponse } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

const GET_PEOPLE_LIMIT = 50

function getPeople(query: GetPeopleQuery): Promise<GetPeopleResponse> {
  return requestApiJsonOrThrow<GetPeopleResponse>('admin/people', {
    params: query,
  })
}

export const peopleQuery = (queryParams: GetPeopleQuery) => ({
  queryKey: ['people', queryParams],
  queryFn: ({ pageParam = 0 }: { pageParam?: number }) =>
    getPeople({
      limit: GET_PEOPLE_LIMIT.toString(),
      offset: pageParam.toString(),
      ...queryParams,
    }),
  getNextPageParam: (lastPage: GetPeopleResponse, pages: GetPeopleResponse[]) => {
    if (lastPage.data.length < GET_PEOPLE_LIMIT) return
    return pages.length * GET_PEOPLE_LIMIT
  },
})
